export enum PalantirTooltipPositionEnum {
  'bottom' = 'bottom',
  'bottom-left' = 'bottom-left',
  'bottom-right' = 'bottom-right',
  'left' = 'left',
  'right' = 'right',
  'top' = 'top',
  'top-left' = 'top-left',
  'top-right' = 'top-right',
}

export type PalantirTooltipPosition = keyof typeof PalantirTooltipPositionEnum;
